import { BasePartyDto, PartyStatus, PartyType } from '../components/Form/Party/PartyForm'

export type ListItemDto = {
    id: string
    type: PartyType
    displayName: string
}

export type PartyOverviewItemDto = ListItemDto & {
    email: string
    phoneNumber: string
    lastName: string
    status: PartyStatus
    identificationVerified?: boolean
}

export enum PartyAction {
    GetOverview = 'GET_PARTY_OVERVIEW',
    GetList = 'GET_PARTY_LIST',
    Reset = 'RESET_PARTIES',
}

export type LegalPersonMutationDto = BasePartyDto & {
    name: string
    legalStructure: string
    poBoxAddressStreet: string
    poBoxAddressNumber: string
    poBoxAddressPostalCode: string
    poBoxAddressLocality: string
    poBoxAddressCountry: string
    financeTermInvoice: number
    financeTermPayment: number
    financeEmail: string
    vatNumber: string
    cocNumber: string
    fileReferenceRequired?: boolean
    reference?: string
}

export function isPartyOverviewItem(party: ListItemDto | PartyOverviewItemDto): party is PartyOverviewItemDto {
    return (<PartyOverviewItemDto>party).status !== undefined
}
